import React from "react";
import { LightbulbIcon } from "lucide-react";
import { challenges } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Challenges() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-166" data-mp="2cyxhnmseg5n0">
      <div className="mx-auto max-w-3xl" data-id="element-167" data-mp="2cyfdm3zhwn4j">
        <p className="font-display text-sm font-extrabold uppercase tracking-wide text-brand" data-id="element-168" data-mp="2hxilrxarv9gq">Does any of this sound familiar?</p>
        <h2 className="mt-3 font-display text-3xl font-black uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-169" data-mp="22zgdj9sspzt5">
          6 professional challenges this collection was designed to address
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-170" data-mp="1u0uyhomj92x4">
          If you work or study in clinical nutrition, particularly renal nutrition, you may recognize some of these situations.
        </p>

        <ol className="mt-10 space-y-10" data-id="element-171" data-mp="3of5pa2mou75j">
          {challenges.map((c, i) => <li key={c.title} className="grid grid-cols-[auto_1fr] gap-4 sm:gap-5" data-id="element-172" data-mp="3td794prxuai2" data-mpi={i}>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ink font-display text-lg font-black text-cta" data-id="element-173" data-mp="xbvuabr4trwl">{i + 1}</span>
              <div data-id="element-174" data-mp="tak0rv550mj4">
                <h3 className="pt-1.5 font-display text-xl font-black uppercase leading-tight text-ink" data-id="element-175" data-mp="t8zhj1o9wq0k">{c.title}</h3>
                <div className="mt-3 space-y-3 text-[16px] leading-relaxed text-muted" data-id="element-176" data-mp="123dwf34w5yj5">
                  {c.body.map(p => <p key={p} data-id="element-177" data-mp="eekw6uh8l4iq">{p}</p>)}
                </div>
                <div className="mt-4 flex gap-3 rounded-2xl bg-sky p-4" data-id="element-178" data-mp="acg4406fsfy7">
                  <LightbulbIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-179" data-mp="aeanvb5z220p" />
                  <p className="text-[15px] leading-snug text-ink" data-id="element-180" data-mp="jcme3c2xexsm">
                    <strong className="text-brand" data-id="element-181" data-mp="jbbapdde7s21">The Blueprint approach:</strong> {c.approach}
                  </p>
                </div>
              </div>
            </li>)}
        </ol>

        <div className="mt-14 rounded-3xl bg-ink p-6 text-white sm:p-8" data-id="element-182" data-mp="1ur9t47ugnqfx">
          <p className="font-display text-2xl font-black uppercase leading-tight text-cta" data-id="element-183" data-mp="22rfqone6p5rg">The challenge isn’t always a lack of information.</p>
          <p className="mt-3 text-lg font-semibold" data-id="element-184" data-mp="26w5ia01t7y6k">Sometimes, the real challenge is organizing the information you already have.</p>
          <p className="mt-3 text-[16px] leading-relaxed text-white/80" data-id="element-185" data-mp="2gss5uwlit3ca">
            RENAL NUTRITION CLINICAL BLUEPRINT™ brings related educational topics together in one collection, giving you a practical starting point for building a more organized professional reference library.
          </p>
        </div>

        <SectionCta heading="Explore the complete Blueprint" label="Get the full collection" data-id="element-186" data-mp="1t2e8qro2weau" />
      </div>
    </section>;
}